/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'app/core/animations/route.animations';
import { ClientSubscriptionItem } from 'app/features/admin/clients/model/ClientSubscription';
import { SubscriptionLengthType, SubscriptionType } from 'app/core/models/common-types';
import { APP_MENU_PRICING, APP_TITLE_LONG } from 'app/core/models/common-ux-types';
import { clientSubscriptionData } from '../pricing.data';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  clientSubscriptionItems: ClientSubscriptionItem[] = clientSubscriptionData;
  appMenuProduct = APP_MENU_PRICING;
  APP_TITLE_LONG = APP_TITLE_LONG;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SubscriptionType = SubscriptionType;
  subscriptionLengthType = SubscriptionLengthType;

  constructor(private router: Router) { }

  ngOnInit() {
    // console.log('MS products ', this.products);
  }

  onSelectPricing(subscriptionType: SubscriptionType) {
    const navigationExtras: NavigationExtras = {
      state: {
        // transd: 'TRANS001',
        // workQueue: false,
        subscriptionType: subscriptionType,
        // code: '003'
      },
    };
    this.router.navigate(['/contact-us'], navigationExtras);
  }

  // onSelectPricing(subscriptionType: SubscriptionType) {

  //   console.log('MS PricingComponent subscriptionType', subscriptionType);
  // }
  // onSelectPricing50Off() {
  //   console.log('MS onSelectPricing50Off');
  //  this.router.navigate(['/contact-us']);
  // }
  // onSelectPricing30DayTrial() {
  //   console.log('MS onSelectPricing30DayTrial');
  //  this.router.navigate(['/contact-us']);
  // }

  openLink(link: string) {
    window.open(link, '_blank');
  }
}

// this.router.navigate(['action-selection'], { state: { example: 'bar' } });
